/** DB `status` can be `assigned` without a linked unit (stale row / manual API). UI follows actual asset link. */
export function displayQrCodeStatusLabel(qr: {
  status: string;
  asset_instance?: unknown | null;
}): string {
  const hasUnit = Boolean(qr.asset_instance);
  if (hasUnit) return qr.status;
  if (qr.status === 'printed' || qr.status === 'damaged') return qr.status;
  return 'unassigned';
}

export const qrStatusBadgeClassName: Record<string, string> = {
  generated: 'bg-gray-500',
  printed: 'bg-blue-500',
  assigned: 'bg-green-500',
  active: 'bg-emerald-500',
  damaged: 'bg-red-500',
  unassigned: 'bg-slate-500',
};
